import React from 'react';
import {Form, Input, Select, Col, Row,  message } from 'antd';
import ModalDom from '../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {
    dicExecutionCycle
} from '../../../../axios/dictionaries';
import {
    API_hsbPayChannel_copyHsbPayChannelConfigClrgRule,
    API_Merchant_findHsbPayChannelConfigAll,
    API_Merchant_getHsbAccountingRulesList,
    API_Merchant_getHsbMerchantInfoList,
} from "../../../../axios/config";
import {formatTime} from "../../../../utils";

const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "拷贝分账规则",
            radioLessReliefTypeValue:false,
            clrgRuleList: [], // 分账规则编号 下拉
            hsbPayChannelList:[],//惠市宝支付渠道
            hsbMerchantList:[], // 商户编号 下拉
            merchantData: [],
            buildingData: [],
            selectUpperLimitValue: false,
            checkedKeys: [], //选中的房源
            data: {
                houseLayout: [],
            },
        }
    }

    pullHouseMessage = (merchantId,jh) => { //拉取房源信息

        this.setState({ loading: true });
        postFrom({
            url: config.API_building_findBuildingList, data: {
                merchantId
            }
        }).then(res => {
            this.setState({ buildingData: res, loading: false }, () => {
                for (let i = 0; i < res.length; i++) {
                    this.handleGetFloor(res[i].id)
                }
            });
        }).catch(err => {
            message.error(err.message || '获取房源（小区/楼栋）列表失败');
            this.setState({ loading: false });
        });
    }

    postClrgRuleList() {
        post({ url: API_Merchant_getHsbAccountingRulesList }).then(res => {
            this.setState({ clrgRuleList: res })
        })
    }

    postHsbMerchantInfoList() {
        post({ url: API_Merchant_getHsbMerchantInfoList }).then(res => {
            this.setState({ hsbMerchantList: res })
        })
    }

    handleGetFloor = (buildingId) => {
        postFrom({ url: config.API_hsbPayChannel_findBuildingHouseList, data: { buildingId } }).then(res => {
            let { data: { projectHouses }, checkedKeys, buildingData } = this.state;
            let existing = []; //存放当前项目关联的房源
            if (projectHouses instanceof Array) {
                existing = projectHouses.filter(item => +item.buildingId === buildingId);
            }
            let arr = [].concat(existing, res); //连接被关联的房源与未被关联的房源
            arr.sort((a, b) => a.floor - b.floor); //针对楼层排序
            let floor = [];
            arr.forEach(el => { //生成出分楼层房号的数组
                let value = floor.find(item => item.name === `楼层：${el.floor}`);
                if (value) {
                    value.children.push({ name: `房号：${el.roomNo}`, id: `houseId${el.houseId}`, isChild: true })
                } else {
                    floor.push({
                        name: `楼层：${el.floor}`,
                        id: `${el.houseId}·${el.floor}`,
                        children: [
                            { name: `房号：${el.roomNo}`, id: `houseId${el.houseId}`, isChild: true }
                        ]
                    })
                }
            });
            floor.forEach((el => { //针对房号排序
                el.children.sort((a, b) => a.name.slice(3) - b.name.slice(3));
            }));
            let nowBuilding = buildingData.find(item => item.id === buildingId);
            nowBuilding ? nowBuilding.children = floor : null;
            for (let i = 0; i < existing.length; i++) { //加入已被关联房源的选中
                if (checkedKeys.indexOf(`houseId${existing[i].houseId}`) === -1) {
                    checkedKeys.push(`houseId${existing[i].houseId}`);
                }
            }
            this.setState({ buildingData, checkedKeys });
        }).catch(err => {
            message.error(err.message || '获取未关联房源列表失败');
        });
    }

    handleLessReliefTypeChange = (e) => { // 最低减免类型
        const radioLessReliefTypeValue = e.target.value
        this.setState({
            radioLessReliefTypeValue
        })
    }

    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
            merchantData,
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="支付渠道">
                                    {getFieldDecorator('hsbPayChannelConfigId', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.hsbPayChannelConfigId
                                    })(
                                        <Select   placeholder="请选择支付渠道"  showSearch  optionFilterProp={'children'}>
                                            {this.state.hsbPayChannelList.map(e => (
                                                <Select.Option key={e.id} value={e.id}>{e.projectName}</Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="复制执行周期">
                                    {getFieldDecorator('executionCycle', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.executionCycle
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择执行周期"
                                            optionFilterProp={'children'}
                                        >
                                            {dicExecutionCycle.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>

                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="目标执行周期">
                                    {getFieldDecorator('newExecutionCycle', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.newExecutionCycle
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择执行周期"
                                            optionFilterProp={'children'}
                                        >
                                            {dicExecutionCycle.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }


    handleCancel = () => { //关闭页面
        this.props.handleCancel();

        this.setState({ data: {}, loading: false, title: "拷贝分账规则",buildingData: [], checkedKeys: [],selectUpperLimitValue:false });
    }

    initPack = () => {
        this.forceUpdate();
        this.postHsbPayChannelConfigAll();
    }

    handleUpperLimitChange = (e) => { // 是否开启建行

        const selectUpperLimitValue = e===1?true:false
        this.setState({
            selectUpperLimitValue
        })
    }

    handleFormChange = (data) => {
        if (!data.clrgRuleId) {
            this.state.data.rulesMemberListList=[];
        } else {
            console.log(data);

            let rulesMemberListList = this.state.clrgRuleList.filter(obj => obj.clrgRuleId === data.clrgRuleId)[0].rulesMemberListList;

            console.log(rulesMemberListList);

            rulesMemberListList = rulesMemberListList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
                item = {
                    id: item.id || 0,
                    key: index,
                    splitAccountA: item.seqNo == null ? '' : item.seqNo,
                    splitAccountE: '',

                };
                return item
            });
            //判断是否存在默认的key
            this.state.data.rulesMemberListList=rulesMemberListList;
            // this.setState({data: {rulesMemberListList:rulesMemberListList});
        }

    }

    postHsbPayChannelConfigAll =() =>{
        post({ url: API_Merchant_findHsbPayChannelConfigAll }).then(res => {
            this.setState({ hsbPayChannelList: res })
        })
    }



    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "拷贝分账规则" });
        postFrom({ url: config.API_hsbPayChannel_getHsbPayChannelConfigClrgRuleById+"?id="+id, data: { } }).then(res => {

            if(res.memberList) {
                res.rulesMemberListList = res.memberList.map((item, index) => { //添加一个key，以便增加一栏时数据不错乱
                    item = {
                        id: item.id || 0,
                        key: index,
                        splitAccountA: item.seqNo == null ? '' : item.seqNo,
                        splitAccountB: '',
                        splitAccountC: '',
                        splitAccountD: '',
                        splitAccountE: item.mktMrchId,
                        splitAccountF: '',
                        splitAccountG: ''
                    };
                    return item
                });
            }

            this.setState({ data:{ ...res, id },selectUpperLimitValue:(res.upperLimit?res.upperLimit==1:false), loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });


    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.setState({ loading: true });

                post({ url: config.API_hsbPayChannel_copyHsbPayChannelConfigClrgRule, data: values }).then(res => {
                    message.success('复制成功');
                    this.props.handleGetList();
                    this.handleCancel();
                }).catch(err => {
                    message.error(err.message || '复制失败');
                    this.setState({ loading: false });
                })
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/HsbPayClrgRule/components/ListCopy/index.js